import { createApi } from "@reduxjs/toolkit/query/react"
import { SharedAccessPatternUsEnum } from "shared/sharedAccessPatternsData"
import { baseQuery } from "../baseQuerySl2"

export type IoTCreds = {
  token: string
  tokenSignature: string
  authorizerName: string
  tokenKeyName: string
  iotEndpoint: string
}
type GetIotCreds = {
  body?: Record<string, any>
  params: Record<string, any>
}

// Define a service using a base URL and expected endpoints
export const meApi = createApi({
  reducerPath: "meApi",
  baseQuery,
  endpoints: (builder) => ({
    getMe: builder.query({
      query: (tenantId: string = "noId") => ({
        url: "things",
        params: {
          "ap.name": SharedAccessPatternUsEnum.GetMe,
          "ap.tenantId": tenantId,
          tenantId,
        },
      }),
    }),
    getIoTCreds: builder.mutation<
      { data?: IoTCreds; error?: any },
      GetIotCreds
    >({
      query: ({ params = {}, body }) => ({
        url: "iot/creds",
        method: "POST",
        params,
        body,
      }),
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetMeQuery, useGetIoTCredsMutation } = meApi
